var i="\nvoid getViewDir() {\n    dViewDirW = normalize(view_position - vPositionW);\n}\n";export{i as default};
